import React from 'react';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';

import {
  getPageBackgroundColor,
  getSectionNavLighterColor
} from 'styles/helpers/getThemeStyles';
import CartDrawerPromotions from 'bento-ordering/cart/components/CartDrawerPromotions';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  paddingBottom: '.5rem',
  backgroundColor: getPageBackgroundColor(theme),
  borderBottom: `1px solid ${getSectionNavLighterColor(theme)}`
}));

function CartDrawerPromotionsWrapper() {
  return (
    <StyledBox>
      <CartDrawerPromotions />
    </StyledBox>
  );
}

export default CartDrawerPromotionsWrapper;
